"use client";

import { useTranslations } from "next-intl";

import { tp } from "@/shared/utils/typograf";
import { Button } from "@/shared/components/button";
import { TELEGRAM_BOT_URL } from "@/shared/constants/telegram";
import { APP_BASE_URL } from "@/shared/constants/appBaseUrl";

import ShieldHalfIcon from "@/shared/icons/shield-half.svg";
import TelegramIcon from "@/shared/icons/telegram.svg";
import BrowserIcon from "@/shared/icons/browser.svg";
import RocketIcon from "@/shared/icons/rocket.svg";
import DeviceLaptopIcon from "@/shared/icons/device-laptop.svg";
import Image from "next/image";

export const Jumbotron = () => {
  const t = useTranslations("jumbotron");
  const tCta = useTranslations("common.cta");

  return (
    <div className="jumbotron-container">
      <div className="jumbotron-background section-container pt-28 pb-14 lg:h-200 lg:pt-50 lg:pb-25">
        <div className="relative z-20 h-full flex flex-col justify-between gap-12 lg:gap-0">
          {/*
            gap, а не space-y: на десктопе айфон здесь абсолютный, и margin от
            space-y всё равно сместил бы его вверх — gap на такие элементы не действует.
          */}
          <div className="flex flex-col gap-6 lg:gap-10.5">
            <div className="space-y-3 text-center lg:text-left">
              <h1 className="lg:max-w-180 text-[32px] leading-9.5 font-semibold lg:text-[50px] lg:leading-15">
                {tp.execute(t("title"))}
              </h1>
              <p className="text-[#C7C7C7] lg:max-w-135 text-base leading-6 lg:text-xl lg:leading-6.5">
                {tp.execute(t("subtitle"))}
              </p>
            </div>
            <Image
              src="/images/app-preview.png"
              width={371}
              height={636}
              alt="App Preview"
              className="jumbotron-iphone"
              quality={100}
            />
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
              <Button
                className="w-full lg:w-auto"
                render={
                  <a
                    href={TELEGRAM_BOT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                }
              >
                <TelegramIcon className="size-5" />
                <span>{tp.execute(tCta("openInTelegram"))}</span>
              </Button>
              <Button
                variant="secondary"
                className="w-full lg:w-auto"
                render={
                  <a
                    href={APP_BASE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                }
              >
                <BrowserIcon className="size-5" />
                <span>{tp.execute(tCta("openInBrowser"))}</span>
              </Button>
            </div>
          </div>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-10.5">
            <div className="flex items-start gap-3">
              <ShieldHalfIcon className="size-9.5 shrink-0" />
              <div className="space-y-1">
                <h5 className="font-medium text-base leading-6">
                  {tp.execute(t("features.security.title"))}
                </h5>
                <p className="lg:max-w-28 text-[#7B7B87] text-sm leading-5">
                  {tp.execute(t("features.security.subtitle"))}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <RocketIcon className="size-9.5 shrink-0" />
              <div className="space-y-1">
                <h5 className="font-medium text-base leading-6">
                  {tp.execute(t("features.fastOperations.title"))}
                </h5>
                <p className="lg:max-w-40 text-[#7B7B87] text-sm leading-5">
                  {tp.execute(t("features.fastOperations.subtitle"))}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <DeviceLaptopIcon className="size-9.5 shrink-0" />
              <div className="space-y-1">
                <h5 className="font-medium text-base leading-6">
                  {tp.execute(t("features.easyInterface.title"))}
                </h5>
                <p className="lg:max-w-40 text-[#7B7B87] text-sm leading-5">
                  {tp.execute(t("features.easyInterface.subtitle"))}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
